import React, { useState } from "react"
import { connect } from "react-redux"
import { Row, Col, Container } from "reactstrap"
import InfoPopup from "./infoPopup"

import a_cap from "../../images/logoBits/a_cap.svg"
import d_cap from "../../images/logoBits/d_cap.svg"
import r_cap from "../../images/logoBits/r_cap.svg"
import a_lower from "../../images/logoBits/a_lower.svg"
import d_lower from "../../images/logoBits/d_lower.svg"
import e_lower from "../../images/logoBits/e_lower.svg"
import m_lower from "../../images/logoBits/m_lower.svg"
import n_lower from "../../images/logoBits/n_lower.svg"
import p_lower from "../../images/logoBits/p_lower.svg"
import r_lower from "../../images/logoBits/r_lower.svg"
import t_lower from "../../images/logoBits/t_lower.svg"
import asterisk from "../../images/logoBits/asterisk.svg"
import crop from "../../images/logoBits/crop-symbol.svg"

import a_cap_green from "../../images/logoBits/a_cap_green.svg"
import d_cap_green from "../../images/logoBits/d_cap_green.svg"
import r_cap_green from "../../images/logoBits/r_cap_green.svg"
import a_lower_green from "../../images/logoBits/a_lower_green.svg"
import d_lower_green from "../../images/logoBits/d_lower_green.svg"
import e_lower_green from "../../images/logoBits/e_lower_green.svg"
import m_lower_green from "../../images/logoBits/m_lower_green.svg"
import n_lower_green from "../../images/logoBits/n_lower_green.svg"
import p_lower_green from "../../images/logoBits/p_lower_green.svg"
import r_lower_green from "../../images/logoBits/r_lower_green.svg"
import t_lower_green from "../../images/logoBits/t_lower_green.svg"
import asterisk_green from "../../images/logoBits/asterisk_green.svg"
import crop_green from "../../images/logoBits/crop-symbol_green.svg"

const LogoBox = ({ logoTheme, mobile, showAnnouncement }) => {
  let [destroy, setDestroy] = useState(false)
  let invert = logoTheme === "black"
  return (
    <Container fluid>
      <Row
        id="logoBox_animated"
        className={`bg-${logoTheme} ${destroy ? "destroy" : ""}`}
      >
        <Col className="d-flex flex-column justify-content-start alig-items-start">
          <div id="reed" className="word">
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? r_cap_green : r_cap}
                alt=""
                className="letter"
                id="reed_r"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? e_lower_green : e_lower}
                alt=""
                className="letter"
                id="reed_e"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? e_lower_green : e_lower}
                alt=""
                className="letter"
                id="reed_e_2"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? d_lower_green : d_lower}
                alt=""
                className="letter"
                id="reed_d"
              />
            </span>
          </div>
          <div id="art" className="word">
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? a_cap_green : a_cap}
                alt=""
                className="letter"
                id="art_a"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? r_lower_green : r_lower}
                alt=""
                className="letter"
                id="art_r"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? t_lower_green : t_lower}
                alt=""
                className="letter"
                id="art_t"
              />
            </span>
          </div>
          <div id="department" className="word">
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? d_cap_green : d_cap}
                alt=""
                className="letter"
                id="dept_d"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? e_lower_green : e_lower}
                alt=""
                className="letter"
                id="dept_e"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? p_lower_green : p_lower}
                alt=""
                className=" letter"
                id="dept_p"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? a_lower_green : a_lower}
                alt=""
                className="letter"
                id="dept_a"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? r_lower_green : r_lower}
                alt=""
                className="letter"
                id="dept_r"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? t_lower_green : t_lower}
                alt=""
                className="letter"
                id="dept_t"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? m_lower_green : m_lower}
                alt=""
                className="letter"
                id="dept_m"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? e_lower_green : e_lower}
                alt=""
                className="letter"
                id="dept_e_2"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? n_lower_green : n_lower}
                alt=""
                className="letter"
                id="dept_n"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? t_lower_green : t_lower}
                alt=""
                className="letter"
                id="dept_t_2"
              />
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setDestroy(!destroy)}
              onKeyDown={() => setDestroy(!destroy)}
            >
              <img
                src={invert ? crop_green : crop}
                alt=""
                className="letter"
                id="registered"
                width="40"
              />
            </span>
          </div>
        </Col>
        {!mobile && <InfoPopup announcement />}
      </Row>
    </Container>
  )
}

export default connect(
  state => ({
    mobile: state.global.mobile,
    logoTheme: state.navbar.logoTheme,
    infoPopupData: state.global.infoPopupData,
    showAnnouncement: state.global.showAnnouncementBar,
  }),
  null
)(LogoBox)
